import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { loginWithGoogle } from "@/lib/auth";
import { ShieldCheck, Heart, Building2 } from "lucide-react";

export default function Login() {
  const [params] = useSearchParams();
  const error = params.get("error");
  return (
    <main className="max-w-4xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center" data-testid="login-page">
      <div>
        <div className="eyebrow mb-3">Sign in</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Welcome back.</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Sign in with Google to save favorites, track your inquiries, and manage the listings you publish.
        </p>
        <Button
          onClick={() => loginWithGoogle("/profile")}
          className="mt-8 rounded-full bg-primary hover:bg-primary/90 h-12 px-8"
          data-testid="login-google-btn"
        >
          <svg className="w-5 h-5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.5 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.9 18.9 13 24 13c3.1 0 5.9 1.2 8 3l5.7-5.7C34.5 6.1 29.6 4 24 4 16 4 9.1 8.5 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.5 0 10.4-2.1 14.1-5.5l-6.5-5.5C29.5 34.9 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-8L6.1 33C8.9 39.4 15.9 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.7l6.5 5.5C41.6 35.5 44 30.1 44 24c0-1.2-.1-2.4-.4-3.5z"/></svg>
          Continue with Google
        </Button>
        {error && (
          <p className="text-sm text-destructive mt-4" data-testid="login-error">
            Sign-in failed. Please try again.
          </p>
        )}
        <p className="text-xs text-muted-foreground mt-6">
          By continuing you agree to our <Link to="/services" className="underline">terms</Link>.
        </p>
      </div>
      <div className="space-y-3">
        <Perk icon={Heart} title="Save favorites" text="Bookmark properties and revisit them anytime." />
        <Perk icon={Building2} title="Manage your listings" text="Track status, edit details, and see inquiries." />
        <Perk icon={ShieldCheck} title="Trusted & secure" text="Google-verified accounts. Session encrypted." />
      </div>
    </main>
  );
}

function Perk({ icon: Icon, title, text }) {
  return (
    <div className="bg-card border border-border rounded-2xl p-5 flex items-start gap-4">
      <div className="w-10 h-10 rounded-full bg-primary/10 grid place-items-center text-primary shrink-0">
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <div className="font-display text-lg font-semibold">{title}</div>
        <p className="text-sm text-muted-foreground mt-1">{text}</p>
      </div>
    </div>
  );
}
